import { render, staticRenderFns } from "./SharedLinkCreateDialogBox.vue?vue&type=template&id=6c45b96f&scoped=true&"
import script from "./SharedLinkCreateDialogBox.vue?vue&type=script&lang=js&"
export * from "./SharedLinkCreateDialogBox.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkCreateDialogBox.vue?vue&type=style&index=0&id=6c45b96f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c45b96f",
  null
  
)

export default component.exports